import React, { useState } from "react";
import "../../styles/Services.css";
import { FaMinus, FaPlus } from "react-icons/fa";
import { RiArrowRightSLine } from "react-icons/ri";
import Application_bg_img from "../../bg_images/S_app_bg_img.png";
import { useNavigate } from "react-router-dom";
import { HiArrowNarrowRight } from "react-icons/hi";



const Servicesfaqs = [
  {
    question: "What is cloud optimization?",
    answer:
      "Cloud optimization is the process of analyzing and improving cloud resources to maximize efficiency, reduce costs, and ensure scalability without compromising performance or security.",
  },
  {
    question: "What are cloud optimizition tools",
    answer:
      "These are software solutions that help manage and optimize cloud resources. Examples include AWS Cost Explorer, Azure Advisor, and third-party platforms like CloudHealth",
  },
  {
    question: "What is a cloud optimization strategy?",
    answer:
      "cloud optimization strategy outlines the steps and techniques required to improve the efficiency of your cloud environment, such as resource right-sizing, cost management, and workload balancing.",
  },
  {
    question: "How can cloud optimization solutions benefit my business?",
    answer:
      "They can reduce costs, improve application performance, enhance security, and streamline operations, ensuring your cloud infrastructure meets your business demands effectively",
  },
];

const CloudOptimization = () => {

  const navigate = useNavigate();
  const [ServicesopenIndex, ServicessetOpenIndex] = useState(null); // Removed `number | null`
  
    const handleToggle = (index) => {
      ServicessetOpenIndex(ServicesopenIndex === index ? null : index);
    };
  return (
    <div className="Service_Container">
      {/* Cousals end */}

      <div
        className="Service_sec1"
        style={{
          backgroundImage: `url(${Application_bg_img})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "98.5vw",
        }}
      >
        <section className="Service_sec1_one">
          <h5>
            Services{" "}
            <span>
              <RiArrowRightSLine className="servrighticon" />
            </span>{" "}
            Cloud Optimization
          </h5>
          <h2>Optimize Your Cloud, Maximize Your ROI</h2>
          <p>
            Simplify your cloud environment and boost efficiency with Arshil’s
            comprehensive cloud optimization services.
          </p>
          <button onClick={() => navigate("/contact")} className="S_sec1_btn1">
            Schedule a Free Consultation
            <HiArrowNarrowRight className="psec1arrow" />
            {/* <MdArrowRightAlt className="psec1arrow" /> */}
          </button>
        </section>
        <section>
          <img
            className="ServiceHeroImg"
            src="images/ServiceHeroImg.png"
            alt=""
          />
        </section>
      </div>

      {/* Sec 2  */}

      <div className="Service_sec2">
        <section className="Service_sec2_in1">
          <h2>What we Offer as Cloud Optimization Company</h2>
          <section className="Service_sec2_in1_h4C">
            <section>
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2_img1.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Resource Utilization Analysis:
                </span>{" "}
                Identify underutilized or idle resources to cut unnecessary
                costs.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2_img2.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Performance Tuning:
                </span>{" "}
                Optimize workloads and configurations for peak performance.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              {" "}
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2_img3.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Cost Management:
                </span>{" "}
                Implement strategies to control and predict cloud spending.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              {" "}
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2-img4.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Security Enhancements:
                </span>{" "}
                Strengthen your cloud environment with robust security measures.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              {" "}
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2_img5.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Scalability Planning:
                </span>{" "}
                Ensure your infrastructure supports future growth and demand.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              {" "}
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2_img6.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Cloud Optimization Tools:
                </span>{" "}
                Leverage native cloud optimization solutions and third-party
                tools for efficient resource management.
              </h4>
            </section>
          </section>

          <section>
            <button
              onClick={() => navigate("/contact")}
              className="Service_sec2_in1_button"
            >
              Get a Free Quote{" "}
              <HiArrowNarrowRight className="s_sec2demoarrow" />
            </button>
          </section>
        </section>

        <section>
          <img className="s_sec2_img1" src="../images/S_cloud_img.png" alt="" />
        </section>
      </div>

      {/* Sec 3 */}
      <div className="Service_sec3">
        <section className="Service_sec3_one">
          <h2>Why Choose Arshil for Cloud Optimization?</h2>
          <p>
            At Arshil, we offer end-to-end cloud optimization services that
            focus on performance, cost-efficiency, and scalability. Here’s why
            you should choose Arshil:
          </p>
        </section>

        <section className="Service_sec3_two">
          <section className="Service_sec3_two_in1">
            <img src="../images/s_c_sec3_img1.png" alt="" />
            <h5>Customized Strategies</h5>
          </section>
          <section className="Service_sec3_two_in1">
            <img src="../images/s_c_sec3_img2.png" alt="" />
            <h5>Innovative Tools and Techniques</h5>
          </section>
          <section className="Service_sec3_two_in1">
            <img src="../images/s_c_sec3_img3.png" alt="" />
            <h5>Transparent Reporting</h5>
          </section>

          <section className="Service_sec3_two_in1">
            <img src="../images/s_c_sec3_img4.png" alt="" />
            <h5> Expert Team</h5>
          </section>
          <section className="Service_sec3_two_in1">
            <img src="../images/s_c_sec3_img5.png" alt="" />
            <h5> End-To-End Support</h5>
          </section>

          <section className="Service_sec3_two_in1">
            <img src="../images/s_c_sec3_img6.png" alt="" />
            <h5> Certified Cloud expertise</h5>
          </section>
        </section>
      </div>

      {/* sec 4  */}

      <div className="Service_sec4">
        <h1> Our Approach to Cloud Optimization </h1>
        <p>
          {" "}
          At Arshil, we deliver cloud optimization services with a focus on
          efficiency, scalability, and business impact. Our approach includes:
        </p>
        <ul className="Service_sec4_ul">
          <li>Assessment and Analysis </li>
          <li>Custom Strategy Development</li>
          <li>Cost Optimization</li>
          <li>Performance Enhancement</li>
          <li>Security and Compliance</li>
          <li>Continuous Monitoring</li>
          <li>Training and Support</li>
        </ul>
      </div>

      {/* Sec 5 */}

      <section className="Service_sec5_in1_FaQ">
        <h1 className="Service_sec5_in1_FaQ_h1">
          Frequently Asked Questions (FAQs)
        </h1>
        {Servicesfaqs.map((faq, index) => (
          <div key={index} className="Service_sec5_in1_FaQ-in1">
            <div className="faq-header" onClick={() => handleToggle(index)}>
              <h5>{faq.question}</h5>
              <span className="icon">
                {ServicesopenIndex === index ? <FaMinus /> : <FaPlus />}
              </span>
            </div>
            {ServicesopenIndex === index && (
              <p className="faq-answer">{faq.answer}</p>
            )}
          </div>
        ))}
      </section>

      {/* Section 6 */}

      <div className="Sec8_container">
        <section>
          <h1>Ready to Optimize Your Cloud?</h1>
          <p>
            Partner with Arshil to take maximum advantage of your cloud
            environment. Our cloud optimization services provide tailored
            strategies, advanced tools, and expert support to ensure maximum
            efficiency and scalability. Contact us today to get started!
          </p>
        </section>

        <section className="Sec8_container_button">
          <button onClick={() => navigate("/contact")}>
            Schedule a Free Consultation
                        <HiArrowNarrowRight className="psec1arrow" />
          </button>
        </section>
      </div>
    </div>
  );
};

export default CloudOptimization;
